/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";
import {
  getRemoveLiquidityParametersDecoder,
  getRemoveLiquidityParametersEncoder,
  type RemoveLiquidityParameters,
  type RemoveLiquidityParametersArgs,
} from "./index.js";

export type EvtRemoveLiquidity = {
  pool: Address;
  position: Address;
  owner: Address;
  params: RemoveLiquidityParameters;
  tokenAAmount: bigint;
  tokenBAmount: bigint;
};

export type EvtRemoveLiquidityArgs = {
  pool: Address;
  position: Address;
  owner: Address;
  params: RemoveLiquidityParametersArgs;
  tokenAAmount: number | bigint;
  tokenBAmount: number | bigint;
};

export function getEvtRemoveLiquidityEncoder(): FixedSizeEncoder<EvtRemoveLiquidityArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["position", getAddressEncoder()],
    ["owner", getAddressEncoder()],
    ["params", getRemoveLiquidityParametersEncoder()],
    ["tokenAAmount", getU64Encoder()],
    ["tokenBAmount", getU64Encoder()],
  ]);
}

export function getEvtRemoveLiquidityDecoder(): FixedSizeDecoder<EvtRemoveLiquidity> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["position", getAddressDecoder()],
    ["owner", getAddressDecoder()],
    ["params", getRemoveLiquidityParametersDecoder()],
    ["tokenAAmount", getU64Decoder()],
    ["tokenBAmount", getU64Decoder()],
  ]);
}

export function getEvtRemoveLiquidityCodec(): FixedSizeCodec<
  EvtRemoveLiquidityArgs,
  EvtRemoveLiquidity
> {
  return combineCodec(
    getEvtRemoveLiquidityEncoder(),
    getEvtRemoveLiquidityDecoder(),
  );
}
